import { useEffect, useState } from "react";
import { APIResponse } from "../../../types/responses/APIResponse";
import { Track } from "../../../types/races/racecard";
import { fetchGet } from "../../../client";
import { LoadingState } from "../../States/states";
import Meeting from "../../Screens/Races/Racecards/Meeting";
import { formatDateLong } from "../../../utils/TimeCalculator";

export const RacesListAttachment = ({
  trackSlug,
  id,
}: {
  trackSlug?: string;
  id: string;
}) => {
  const [data, setData] = useState<Track | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!trackSlug || !id) {
      setLoading(false);
      return;
    }
    const fetchData = async () => {
      try {
        const res: APIResponse<{ track: Track }> = await fetchGet(
          `/racing/tracks/${trackSlug}/races?track_list_id=${id}`
        );
        if (res.track) {
          setData(res.track);
          setError(null);
        } else setError("No track data found");
      } catch (err) {
        setError(
          "Error loading FAQs: " +
            (err instanceof Error ? err.message : "Unknown")
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading)
    return (
      <LoadingState
        name="RacesListAttachmentLoader"
        containerStyle={{ width: "100%" }}
      />
    );

  if (error || !data?.upcoming_meeting?.length) return null;

  return (
    <>
      {data?.upcoming_meeting.map((meeting) => (
        <Meeting
          key={meeting.id}
          meeting={meeting}
          track={{
            name: data?.name,
            slug: data?.slug,
            country_code: data?.country_code,
          }}
          headerOverride={formatDateLong(meeting.date).toUpperCase()}
        />
      ))}
    </>
  );
};

export default RacesListAttachment;
